<template>

<core-filter-advanced-group title="Artists" :count="count">

	<core-filter-input-suggest placeholder="Start typing a artist's name..." :toggle="true" field="artist_name" :filter="value('artists')" api="artists/suggest" data="artists" />

</core-filter-advanced-group>

</template>

<script>

import Group from 'core/mixin/filter/Group.js'

export default {

	mixins: [Group],

	data: function() {

		return {
			fields: ['artists']
		}
	}

}

</script>